/* eslint-disable arrow-body-style */
import React from 'react';
import {
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  IconButton,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { LightTooltip } from '../custom-components/custom-tooltip';

const FeeTypeSection = ({ formik, onFieldBlur }) => {
  return (
    <>
      <FormControl>
        <Typography variant="subtitle1" gutterBottom>
          Fee Type
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              name="fee_type"
              checked={formik.values.fee_type === 'Percentage'}
              onChange={(e) => {
                if (e.target.checked) {
                  formik.setFieldValue('fee_type', 'Percentage');
                } else {
                  formik.setFieldValue('fee_type', '');
                }
              }}
            />
          }
          label="Percentage-Based Fee"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="fee_type"
              checked={formik.values.fee_type === 'Fixed Monthly'}
              onChange={(e) => {
                if (e.target.checked) {
                  formik.setFieldValue('fee_type', 'Fixed Monthly');
                } else {
                  formik.setFieldValue('fee_type', '');
                }
              }}
            />
          }
          label="Fixed Monthly Fee"
        />
        {formik.touched.fee_type && formik.errors.fee_type && (
          <FormHelperText error>{formik.errors.fee_type}</FormHelperText>
        )}
      </FormControl>

      {formik.values.fee_type === 'Percentage' && (
        <>
          <LightTooltip title="Define the percentage of revenue allocated for services rendered.">
            <TextField
              id="percentage_terms"
              name="percentage_terms"
              label="Percentage Terms"
              type="number"
              value={formik.values.percentage_terms}
              onChange={(e) => {
                const nextValue = e.target.value;
                if (nextValue === '') {
                  formik.setFieldValue('percentage_terms', '');
                  return;
                }
                const parsed = parseFloat(nextValue);
                formik.setFieldValue(
                  'percentage_terms',
                  Number.isFinite(parsed) ? String(Math.max(0, parsed)) : formik.values.percentage_terms
                );
              }}
              onBlur={() => onFieldBlur('percentage_terms')}
              error={formik.touched.percentage_terms && Boolean(formik.errors.percentage_terms)}
              helperText={formik.touched.percentage_terms && formik.errors.percentage_terms}
              InputProps={{
                inputProps: { min: 0, step: 0.1 },
                endAdornment: (
                  <>
                    <span>%</span>
                    <IconButton
                      onClick={() => {
                        const value =
                          formik.values.percentage_terms === '' ? 0 : parseFloat(formik.values.percentage_terms, 10);
                        formik.setFieldValue('percentage_terms', Math.max(0, value - 0.1).toFixed(1));
                      }}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        const value =
                          formik.values.percentage_terms === '' ? 0 : parseFloat(formik.values.percentage_terms, 10);
                        formik.setFieldValue('percentage_terms', (value + 0.1).toFixed(1));
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </>
                ),
              }}
            />
          </LightTooltip>
          <TextField
            id="percentage_fee_description"
            name="percentage_fee_description"
            label="Fee Description"
            multiline
            rows={3}
            value={formik.values.percentage_fee_description}
            onChange={formik.handleChange}
            onBlur={() => onFieldBlur('percentage_fee_description')}
            error={formik.touched.percentage_fee_description && Boolean(formik.errors.percentage_fee_description)}
            helperText={formik.touched.percentage_fee_description && formik.errors.percentage_fee_description}
            placeholder="Enter description for the percentage-based fee"
          />
        </>
      )}

      {formik.values.fee_type === 'Fixed Monthly' && (
        <TextField
          id="fixed_monthly_fee"
          name="fixed_monthly_fee"
          label="Fixed Monthly Fee"
          type="number"
          value={formik.values.fixed_monthly_fee}
          onChange={(e) => {
            const nextValue = e.target.value;
            if (nextValue === '') {
              formik.setFieldValue('fixed_monthly_fee', '');
              return;
            }
            const parsed = parseFloat(nextValue);
            formik.setFieldValue(
              'fixed_monthly_fee',
              Number.isFinite(parsed) ? String(Math.max(0, parsed)) : formik.values.fixed_monthly_fee
            );
          }}
          onBlur={() => onFieldBlur('fixed_monthly_fee')}
          error={formik.touched.fixed_monthly_fee && Boolean(formik.errors.fixed_monthly_fee)}
          helperText={formik.touched.fixed_monthly_fee && formik.errors.fixed_monthly_fee}
          InputProps={{
            startAdornment: <span style={{ marginRight: '8px' }}>$</span>,
            inputProps: { min: 0 },
          }}
          placeholder="Enter monthly fee amount"
        />
      )}
    </>
  );
};

export default FeeTypeSection;
